import { useMemo } from "react";
import { useAuth } from "react-oidc-context";

export const useUsername = () => {
  const { user } = useAuth();

  return useMemo(
    () =>
      [user?.profile.firstName, user?.profile.lastName]
        .filter(Boolean)
        .join(" "),
    [user]
  );
};
